/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { ContentFilteringPropsDto } from "./ContentFilteringPropsDto.ts"

export const getProductPageComponentsResponseDtoComponentTypeEnum = {
  TEXT_PARAGRAPH: "TEXT_PARAGRAPH",
  ACTIVITY_LIST: "ACTIVITY_LIST",
  ACTIVITY_LIST_WITH_ICONS: "ACTIVITY_LIST_WITH_ICONS",
  RECYCLED_MATERIALS_INFO: "RECYCLED_MATERIALS_INFO",
  PACKAGING_INFO: "PACKAGING_INFO",
  TRIMAN_FOOTER: "TRIMAN_FOOTER",
  POWERED_BY: "POWERED_BY",
  TRIMAN_FOOTER_POWERED_BY: "TRIMAN_FOOTER_POWERED_BY",
  ECOSCORE: "ECOSCORE",
  BULLETED_LIST: "BULLETED_LIST",
  TEXT_PARAGRAPH_V2: "TEXT_PARAGRAPH_V2",
  LOGO: "LOGO",
  GENERIC_PASSPORT_TITLE: "GENERIC_PASSPORT_TITLE",
  PRODUCT_ATTRIBUTES: "PRODUCT_ATTRIBUTES",
  ORGANIZATION_TITLE: "ORGANIZATION_TITLE",
  PRODUCT_IMAGE: "PRODUCT_IMAGE",
} as const

export type GetProductPageComponentsResponseDtoComponentTypeEnumKey =
  (typeof getProductPageComponentsResponseDtoComponentTypeEnum)[keyof typeof getProductPageComponentsResponseDtoComponentTypeEnum]

export type GetProductPageComponentsResponseDto = {
  /**
   * @type string
   */
  id: string
  /**
   * @description Must be one of the keys of COMPONENT_TYPES enum
   * @type string
   */
  componentType: GetProductPageComponentsResponseDtoComponentTypeEnumKey
  /**
   * @type number
   */
  order: number
  /**
   * @type string
   */
  displaySettingsId: string
  /**
   * @type object
   */
  content: {
    [key: string]: {
      /**
       * @type string | undefined
       */
      type?: string
      /**
       * @type array | undefined
       */
      textContent?: object[]
    }
  }
  configurations: ContentFilteringPropsDto | null
}
